import React, {useEffect, useState} from 'react';
import {FaCircleExclamation, FaTriangleExclamation} from "react-icons/fa6";
import projectUtils from "../../../../../../../utils/project-utils.js";

const DateExpirationRender = (props) => {
    const api = props.api
    const data = props.data
    const { dateExpiration } = props.data;
    const [show, setShow] = useState("");

    const hasRelation = () => {
        let has = false;
        api.forEachNode(row => {
            const {relatedItemId} = row.data;
            if (relatedItemId === data.itemId) has = true
        });

        return has;
    }

    useEffect(() => {
        let givenDate
        const savedDate = data.dateExpiration

        const today = new Date();
        savedDate ? givenDate = new Date(savedDate) : givenDate = null
        const almostDate = new Date();
        almostDate.setDate(today.getDate() + 45);

        if (givenDate && !hasRelation()){
            if (today >= givenDate) {
                setShow("expired")
            }else if (today <= givenDate && almostDate >= givenDate) {
                setShow("toExpire")
            }else{
                setShow("ok")
            }
        }else{
            setShow("ok")
        }
    }, [])


    return (
        <>
            {
                show === "expired" &&
                <span className={"text-red-600 font-bold flex items-center gap-2"}>
                    <p>{projectUtils.formatDate(dateExpiration + 'T00:00:00', 'DD/MM/YYYY')}</p>
                    <FaTriangleExclamation title={"Documento vencido"} className={"mb-[3px]"}/>
                </span>
            }

            {
                show === "toExpire" &&
                <span className={"text-orange-600 font-bold flex items-center gap-2"}>
                    <p>{projectUtils.formatDate(dateExpiration + 'T00:00:00', 'DD/MM/YYYY')}</p>
                    <FaCircleExclamation title={"Documento a vencer"} className={"mb-[3px]"}/>
                </span>
            }

            {
                show === "ok" &&
                <span className={"font-weight-bold d-flex align-items-center"}>
                    {dateExpiration ? projectUtils.formatDate(dateExpiration + 'T00:00:00', 'DD/MM/YYYY') : ""}
                </span>
            }

        </>
    );
};

export default DateExpirationRender;